/**
 * HTTP 클라이언트 설정
 * Axios를 사용하여 API 요청을 처리합니다.
 */
import axios from 'axios';

// API URL 처리: 환경변수에 설정된 URL을 그대로 사용
const apiUrl = process.env.REACT_APP_API_URL;

console.log('API Base URL:', apiUrl);

const httpClient = axios.create({
    baseURL: apiUrl,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true, // 세션 쿠키 유지
});

// 요청 인터셉터 (예: 토큰 추가)
httpClient.interceptors.request.use(config => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// 응답 인터셉터 (예: 에러 공통 처리)
httpClient.interceptors.response.use(
    response => {
        // 응답 데이터 가공 (필요시)
        if (response.status === 200) {
            // console.log('API 호출 성공: ' + response.config.url);
        }

        // blob 응답 타입 처리
        if (response.config.responseType === 'blob') {
            // blob 응답이 제대로 된 Blob 객체인지 확인
            if (!(response.data instanceof Blob)) {
                console.warn('responseType이 blob이지만 Blob 객체가 아닙니다:', response.data);
                // JSON 응답이 blob으로 온 경우 처리
                if (typeof response.data === 'object' && response.data !== null) {
                    return Promise.reject(new Error('서버가 Blob 대신 JSON을 반환했습니다.'));
                }
            }
        }

        return response;
    },
    error => {
        console.error('API error:', error);

        // blob 요청 실패 시 자세한 정보 출력
        if (error.config?.responseType === 'blob' && error.response) {
            console.error('Blob 요청 실패 상세:', {
                url: error.config.url,
                status: error.response.status,
                contentType: error.response.headers['content-type']
            });
        }

        return Promise.reject(error);
    }
);

export default httpClient;
